import { fetchPatch } from 'Services/fetchService.js';
import { nodePath } from 'Config/path.js';

export default async function updateFileDescription(data) {
    const result = await fetchPatch(`${nodePath}/files/update-file-description`, data);

    return result;
}
